var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectdevicePrintericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_6385)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1075,
    transform: "translate(-843 -376)",
    fill: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -53,
    y: -40,
    width: 600,
    height: 219,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -16,
    width: 100,
    height: 100,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0625 21.5625H60.375V8.625C60.375 3.86777 56.5072 0 51.75 0H20.8213C18.5303 0 16.3336 0.90293 14.7164 2.52012L11.1451 6.09141C9.52793 7.70859 8.625 9.90527 8.625 12.1963V21.5625H12.9375V12.1963C12.9375 11.0508 13.3957 9.95918 14.2043 9.15059L17.7756 5.5793C18.5842 4.7707 19.6758 4.3125 20.8213 4.3125H51.75C54.1354 4.3125 56.0625 6.23965 56.0625 8.625V21.5625ZM8.625 30.1875H60.375C62.7604 30.1875 64.6875 32.1146 64.6875 34.5V51.75H60.375V47.4375C60.375 45.0521 58.4479 43.125 56.0625 43.125H12.9375C10.5521 43.125 8.625 45.0521 8.625 47.4375V51.75H4.3125V34.5C4.3125 32.1146 6.23965 30.1875 8.625 30.1875ZM8.625 56.0625V64.6875C8.625 67.0729 10.5521 69 12.9375 69H56.0625C58.4479 69 60.375 67.0729 60.375 64.6875V56.0625H64.6875C67.0729 56.0625 69 54.1354 69 51.75V34.5C69 29.7428 65.1322 25.875 60.375 25.875H8.625C3.86777 25.875 0 29.7428 0 34.5V51.75C0 54.1354 1.92715 56.0625 4.3125 56.0625H8.625ZM56.0625 47.4375V64.6875H12.9375V47.4375H56.0625ZM10.7812 33.4219C9.92344 33.4219 9.10077 33.7626 8.4942 34.3692C7.88764 34.9758 7.54688 35.7984 7.54688 36.6562C7.54688 37.5141 7.88764 38.3367 8.4942 38.9433C9.10077 39.5499 9.92344 39.8906 10.7812 39.8906C11.6391 39.8906 12.4617 39.5499 13.0683 38.9433C13.6749 38.3367 14.0156 37.5141 14.0156 36.6562C14.0156 35.7984 13.6749 34.9758 13.0683 34.3692C12.4617 33.7626 11.6391 33.4219 10.7812 33.4219Z",
    fill: "#B0B0B0",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 20.2857C36.5 19.0214 35.6063 18 34.5 18C33.3937 18 32.5 19.0214 32.5 20.2857V38.5714C32.5 39.8357 33.3937 40.8571 34.5 40.8571C35.6063 40.8571 36.5 39.8357 36.5 38.5714V20.2857ZM34.5 50C35.163 50 35.7989 49.699 36.2678 49.1632C36.7366 48.6273 37 47.9006 37 47.1429C37 46.3851 36.7366 45.6584 36.2678 45.1226C35.7989 44.5867 35.163 44.2857 34.5 44.2857C33.837 44.2857 33.2011 44.5867 32.7322 45.1226C32.2634 45.6584 32 46.3851 32 47.1429C32 47.9006 32.2634 48.6273 32.7322 49.1632C33.2011 49.699 33.837 50 34.5 50Z",
    fill: "#008393"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3292,
    y: -2260,
    width: 9258,
    height: 7325,
    stroke: "#FF1313",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_6385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1075,
    fill: "white",
    transform: "translate(-843 -376)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectdevicePrintericon);
export default __webpack_public_path__ + "static/media/connectdevice-printericon.6c4a5cf833d4bdbe07d7023d44711034.svg";
export { ForwardRef as ReactComponent };